import { useEffect, useState } from "react"
import { getStations, Station, StationsType } from "../api/getStations";



export const useStations = () => {
  const [ stations, setStations ] = useState<Station[]>([]);

  useEffect(() => {
    (async () => {
      const results = await getStations();

      if (results) {
        setStations(results);
      }
    })();
  }, []);

  return {
    stations,
  }
}
